import React, { forwardRef, Ref } from "react";
import { ArrowSmallDownIcon } from "../../../generated";
import { GeneratedIconProps } from "../../icon/GeneratedIconProps";

export interface SmallDirectionalTriangleIconProps extends GeneratedIconProps {
    /** Automatically set rotation based on value. 0 is vertical. */
    rotation: 0 | 90 | 180 | 270;
    /**
     * The size to render the icon at.
     */
    size: 20;
}

export const SmallDirectionalTriangleIcon = forwardRef(
    ({ color, size, rotation, style, ...rest }: SmallDirectionalTriangleIconProps, ref: Ref<HTMLElement>) => (
        <ArrowSmallDownIcon
            color={color}
            ref={ref}
            size={size}
            style={{ transform: `rotate(${rotation + 180}deg)`, ...style }}
            {...rest}
        />
    )
);

SmallDirectionalTriangleIcon.displayName = "SmallDirectionalTriangleIcon";
